import RestResourceService from "../../services/RestResourcesService";
import errorParser from "@/utils/error-parser";


function initialState() {
    return {
        Explanations: [],
    
    }
}

export default {
    state: initialState(),
    getters: {
        DATA_TABLE_EXPLANATIONS: state => {
            return state.Explanations;
        }
    },
    mutations: {
        SET_DATA_TABLE_EXPLANATIONS(state, payload) {
            state.Explanations = payload;
        },
    
    },
    actions: {
        POST_ITEMS_EXPLANATIONS_WITH_SEARCH_QUERY: async ({commit}, payload) => {
           
            return RestResourceService.postResources(payload.debugUrl, payload.searchQuery)
            .then((response) => {
                commit('SET_DATA_TABLE_EXPLANATIONS', response.data.hits);
                
            })
            .catch((error) => {
                errorParser.parse({
                    error: error,
                    redirectTo404Page: false,
                    redirectTo500Page: false,
                    clearAuthData: false,
                    redirectToLoginPage: false,
                    showNotification: false,
                });
                throw new Error(error);
            })
         
        },
        
    }
}
